export enum ZuordnungArt {
    apotheke,
    gruppe,
    kooperation,
}
